module.exports = __webpack_public_path__ + "static/media/ICON_TWITTER_ACTIVE.9b9b20ec.svg";